import { DatePicker } from '@liza/ui/components/atoms/DatePicker';
import { CollapsedFieldRow } from '@liza/ui/components/timing/CollapsedFieldRow';
import { Field, FieldContent, FieldGroup, FieldLabel } from '@liza/ui/components/ui/field';
import { isRecurringScheduleType, type ScheduleType } from '@liza/ui/utils/schedulePicker';
import { useTranslation } from 'react-i18next';

/**
 * Start-date row for every recurring mode, idling as "+ Starts on" until a
 * date is set. When Every… omits it, the schedule anchors to its creation
 * date (task creation defaults `boundsPeriod.start` to `authoredOn`).
 */
export function StartsRow({
  scheduleType,
  startDate,
  onChange,
}: {
  scheduleType: ScheduleType;
  startDate: string;
  onChange: (startDate: string) => void;
}): React.ReactNode {
  const { t } = useTranslation('common');
  if (!isRecurringScheduleType(scheduleType)) return null;
  const content = (
    <FieldGroup>
      <Field>
        <FieldLabel>{t('startsOn')}</FieldLabel>
        <FieldContent>
          <DatePicker value={startDate} onChange={onChange} aria-label={t('startsOn')} />
        </FieldContent>
      </Field>
    </FieldGroup>
  );
  return (
    <CollapsedFieldRow name="starts-on" label={t('startsOn')} hasValue={!!startDate} onClear={() => onChange('')}>
      {content}
    </CollapsedFieldRow>
  );
}
